"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
require("core-js/modules/es6.function.name");
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.$route.name === "home" ? _c("div", {
    staticClass: "side-nav"
  }, [_c("nav", {
    staticClass: "side navbar dark-pill-nav"
  }, [_c("el-tooltip", {
    attrs: {
      placement: "left",
      effect: "light",
      transition: "initial",
      offset: 15,
      "popper-class": "slide-nav-tool"
    }
  }, [_c("div", {
    staticClass: "tooltip-box",
    attrs: {
      slot: "content"
    },
    slot: "content"
  }, [_c("div", {
    staticClass: "kefu_con_one"
  }, [_c("a", {
    attrs: {
      href: "javascript:void(0);"
    },
    on: {
      click: _vm.jumpOnline
    }
  }, [_vm._v("在线咨询")])])]), _c("div", {
    staticClass: "nav-item chat-item",
    attrs: {
      id: "side_kefus"
    },
    on: {
      mouseover: function mouseover($event) {
        return _vm.changeImageOnline(true);
      },
      mouseout: function mouseout($event) {
        return _vm.changeImageOnline(false);
      },
      click: _vm.jumpOnline
    }
  }, [_c("div", {
    staticClass: "chat-circle"
  }, [_c("i", {
    staticClass: "el-icon-chat-dot-square"
  })])])]), _c("el-tooltip", {
    attrs: {
      placement: "left",
      effect: "light",
      transition: "initial",
      offset: 15,
      "popper-class": "slide-nav-tool"
    }
  }, [_c("div", {
    staticClass: "tooltip-box",
    attrs: {
      slot: "content"
    },
    slot: "content"
  }, [_c("div", {
    staticClass: "kefu_con"
  }, [_c("img", {
    attrs: {
      src: require("../../src/assets/static/img/sidenav/06.png"),
      alt: ""
    }
  }), _c("a", {
    attrs: {
      href: "javascript:void(0);"
    }
  }, [_vm._v("400-886-3156")])])]), _c("div", {
    staticClass: "nav-item phone-item",
    attrs: {
      id: "side_kefu"
    },
    on: {
      mouseover: function mouseover($event) {
        return _vm.changeImage(true);
      },
      mouseout: function mouseout($event) {
        return _vm.changeImage(false);
      }
    }
  }, [_c("img", {
    attrs: {
      src: "https://whbj-yellowpage.oss-cn-shenzhen.aliyuncs.com/H5_vue3/%E6%96%B0%E5%AE%98%E7%BD%91/%E7%83%AD%E7%BA%BF%E7%94%B5%E8%AF%9D.svg",
      alt: "",
      width: "25",
      height: "25"
    }
  })])]), _c("el-tooltip", {
    attrs: {
      placement: "left",
      effect: "light",
      transition: "initial",
      offset: 15,
      "popper-class": "slide-nav-tool_app"
    }
  }, [_c("div", {
    attrs: {
      slot: "content"
    },
    slot: "content"
  }, [_c("img", {
    attrs: {
      src: "https://whbj-yellowpage.oss-cn-shenzhen.aliyuncs.com/H5_vue3/%E6%96%B0%E5%AE%98%E7%BD%91/app%E4%B8%8B%E8%BD%BD%E4%BA%8C%E7%BB%B4%E7%A0%81.png",
      alt: ""
    }
  }), _c("div", {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("App下载")])]), _c("div", {
    staticClass: "nav-item phone-item",
    attrs: {
      id: "side_kefu"
    },
    on: {
      mouseover: function mouseover($event) {
        return _vm.changeImage(true);
      },
      mouseout: function mouseout($event) {
        return _vm.changeImage(false);
      }
    }
  }, [_c("img", {
    attrs: {
      src: "https://whbj-yellowpage.oss-cn-shenzhen.aliyuncs.com/H5_vue3/%E6%96%B0%E5%AE%98%E7%BD%91/%E4%B8%8B%E8%BD%BDapp.svg",
      alt: "",
      width: "30",
      height: "30"
    }
  })])]), _c("div", {
    staticClass: "nav-divider"
  }), _c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showTop,
      expression: "showTop"
    }],
    staticClass: "nav-item top-item",
    attrs: {
      id: "side_zhiding"
    },
    on: {
      mouseover: function mouseover($event) {
        return _vm.changeImageback(true);
      },
      mouseout: function mouseout($event) {
        return _vm.changeImageback(false);
      },
      click: _vm.goToTop
    }
  }, [_c("img", {
    attrs: {
      src: "https://whbj-yellowpage.oss-cn-shenzhen.aliyuncs.com/H5_vue3/%E6%96%B0%E5%AE%98%E7%BD%91/%E5%9B%9E%E5%88%B0%E9%A1%B6%E9%83%A8.svg",
      alt: "",
      width: "30",
      height: "30"
    }
  })])], 1)]) : _vm._e();
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;